import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTrending3"><Path fillRule="evenodd" clipRule="evenodd" d="M15.0002 6H22.0002V13H20.0002V9.41421L13.0002 16.4142L9.00015 12.4142L3.00015 18.4142L1.58594 17L9.00015 9.58579L13.0002 13.5858L18.5859 8H15.0002V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending3;
